// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Autoplay, Navigation, Pagination]);

export default function knInitSwiper() {

    // console.log('knInitSwiper');

    document.addEventListener('DOMContentLoaded', function () {

        /* -------------------------------------------
        HOME SLIDER INIT
        ------------------------------------------- */
        var swiper = new Swiper(".knHeroSwiper", {
            autoplay: {
                delay: 4000,
            },
            pagination: {
                el: ".swiper-pagination"
            }
        });

        console.log(swiper);

    }, false);

}